// DatePickerFromTo.jsx
'use client';

import React, { useMemo, useCallback } from 'react';
import SmartDateField from '../../DatePickers/SmartDateField';

const pad = (n) => String(n).padStart(2, '0');
const todayDate = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
const nowLocalHM = () => {
  const d = new Date();
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export default function DatePickerFromTo({
  setSingleDate,
  setTimeValue,
  singleDate,
  timeValue,
  error,
  helperText,
}) {
  // Build SmartDateField value: "YYYY-MM-DDTHH:mm"
  const initialNow = useMemo(() => `${todayDate()}T${nowLocalHM()}`, []);
  const fieldValue = useMemo(() => {
    if (singleDate && timeValue) {
      // timeValue in "HH:mm:ss" → SmartDateField expects minutes precision
      const [hh = '00', mm = '00'] = String(timeValue).split(':');
      return `${singleDate}T${pad(hh)}:${pad(mm)}`;
    }
    // fallback (like your previous currentTime)
    return initialNow;
  }, [singleDate, timeValue, initialNow]);

  const handleChange = useCallback(
    (isoLocal /* "YYYY-MM-DDTHH:mm" */) => {
      if (!isoLocal) return;
      const [d, hm] = String(isoLocal).split('T');
      const [hh = '00', mm = '00'] = (hm || '').split(':');
      setSingleDate(d || '');
      // keep seconds in your store
      setTimeValue(`${pad(hh)}:${pad(mm)}:00`);
    },
    [setSingleDate, setTimeValue]
  );

  return (
    <div className="input-style-check" style={{ padding: 0, width: '100%' }}>
      <div className="d-flex justify-between px-10">
        <p className="text-12 fw-500 ls-2 lh-16">Pick-up Date</p>
      </div>

      <SmartDateField
        type="datetime"
        value={fieldValue}
        setValue={handleChange}
        // match your old disabledDate (block past days; allow any time today)
        minDateTime={`${todayDate()}T00:00`}
        stepMinutes={1}          // allow minute-level selection like "HH:mm"
        showHint={false}
        fullWidth
        sx={{
          border: error ? '1px solid red' : '1px solid transparent',
          borderRadius: 8,
          px: 1,
          fontSize: 14,
        }}
      />

      {error && (
        <div style={{ color: 'red', fontSize: 11 }}>{helperText}</div>
      )}
    </div>
  );
}
